/**
 * Centralized registry of all frontend route paths.
 * Using a flatter structure as requested.
 */
export const PATHS = {
  HOME: "/",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  DASHBOARD: "/dashboard",
  
  // Superadmin & Shared Management
  ACCESS_CONTROL: "/access-control",
  SECURITY_PORTAL: "/security",
  SECURITY_SESSIONS: "/security/sessions",
  SECURITY_AUDIT: "/security/audit",
  SECURITY_PROTECTION: "/security/protection",

  USER_MANAGEMENT: "/users",
  CLIENT_MANAGEMENT: "/manage-clients",
  ADD_CLIENT: "/add-client",
  CUSTOMER_MANAGEMENT: "/manage-customers",
  ADD_CUSTOMER: "/add-customer",
  COURSE_MANAGEMENT: "/manage-courses",
  ADD_COURSE: "/add-courses",
  LIBRARY_MANAGEMENT: "/manage-library",
  LEAVE_MANAGEMENT: "/manage-leaves",
  ADD_LEAVE: "/add-leave",
  
  // Leads & Marketing
  CAMPAIGN_DASHBOARD: "/campaigns",
  LEAD_TRACKING: "/leads-tracking",
  LEAD_ACTIVITIES: "/leads-activities",
  LEAD_ACCOUNTS: "/leads-accounts",
  LEAD_CONTACT: "/leads-contact",
  LEAD_LOST: "/leads-lost",
  LEAD_ALL: "/leads-all",
  
  // Social & Engagement
  SOCIAL_LEADS: "/social-leads",
  SOCIAL_DASHBOARD: "/social-dashboard",
  SOCIAL_KANBAN: "/social-kanban",
  SOCIAL_CAMPAIGNS: "/social-campaigns",
  SOCIAL_INTEGRATIONS: "/social-integrations",
  
  // Operations
  FEES_STRUCTURE: "/fees-structure",
  MANAGE_ATTENDANCE: "/manage-attendance",
  VIEW_ATTENDANCE: "/view-attendance",
  MARK_ATTENDANCE: "/mark-attendance",
  VIEW_LIBRARY: "/view-library",
  ADD_LIBRARY: "/add-library",
  AUTO_DIALER: "/auto-dialer",
  REPORTS: "/reports",
  NOTIFICATIONS: "/notifications",
  
  // Salary / Payroll
  SALARY_PAYOUT: "/salary-payout",
  SALARY_ASSIGNMENT: "/salary-assignment",
  SALARY_CONFIGURATION: "/salary-configuration",
  PAYROLL_RUN: "/payroll-run",

  // Student Portal
  STUDENT_PROFILE: "/profile",
  STUDENT_TIMETABLE: "/timetable",
  STUDENT_ATTENDANCE: "/attendance",
  STUDENT_EXAMINATION: "/examination",
  STUDENT_COURSE_REG: "/course-registration",
  STUDENT_LIBRARY: "/library",
  STUDENT_FEES: "/fees",
  STUDENT_HOSTEL: "/hostel",
  STUDENT_TRANSPORT: "/transport",

  // Teacher Portal
  TEACHER_CLASSES: "/classes",
  TEACHER_SALARY: "/salary",
  TEACHER_LEAVE: "/leave",
  TEACHER_ATTENDANCE: "/mark-attendance",

  // Profile Actions
  VIEW_PROFILE: "/view-profile",
  EDIT_PROFILE: "/edit-profile",
};
